module.exports = __webpack_public_path__ + "img/mapa.3c26f33a.svg";